import React from 'react';

interface TimeSpanDisplayProps {
    value: string;
    hideSeconds?: boolean
}

const TimeSpanDisplay: React.FC<TimeSpanDisplayProps> = ({ value, hideSeconds }) => {
    const formatTimeSpan = (input: string) => {
        if (!input) return "-";

        // Split off milliseconds if present
        const [timePart] = input.split(".");

        // Validate and return
        const parts = timePart.split(":");

        if (parts.length !== 3) {
            // If not in expected format, fallback
            return "-";
        }

        const [hours, minutes, seconds] = parts;
        let result = `${hours}:${minutes}`;

        if (!hideSeconds) {
            result += `:${seconds}`;
        }

        return result;
    };

    return <span>{formatTimeSpan(value)}</span>;
};

export default TimeSpanDisplay;